angular.module('aprima-provider-api').factory('PharmacyRepository',
    ['AprimaRestangular', 'MetadataRepository', '$q', 'moment', 'AprimaAnalytics', 'AprimaCache',
        function (AprimaRestangular, MetadataRepository, $q, moment, AprimaAnalytics, AprimaCache) {
            'use strict';

            var defaultCache;

            return {
                getPharmacy: getPharmacy,
                getPharmacyByMasterPharmacyId: getPharmacyByMasterPharmacyId,
                searchPharmacies: searchPharmacies,
                searchPharmaciesIncludeAllMailOrders: searchPharmaciesIncludeAllMailOrders
            };

            function getDefaultCache() {
                if (!defaultCache) {
                    defaultCache = AprimaCache.Default.httpMode;
                }

                return defaultCache;
            }

            function getPharmacy(id, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'PharmacyRepository', 'api', 'getPharmacy');

                return AprimaRestangular.get().all('lists/pharmacies').one(id).get().finally(timing.stop);
            }

            function getPharmacyByMasterPharmacyId(id, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'PharmacyRepository', 'api', 'getPharmacyByMasterPharmacyId');

                return AprimaRestangular.get().all('lists/masterpharmacies').one(id).get().finally(timing.stop);
            }

            function searchPharmacies(searchText, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'PharmacyRepository', 'api', 'getPharmacy');

                return AprimaRestangular.get().all('lists/pharmacies').withHttpConfig({cache: getDefaultCache()}).getList({query: searchText}).finally(timing.stop);
            }

            function searchPharmaciesIncludeAllMailOrders(searchText, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'PharmacyRepository', 'api', 'getPharmacy');

                return AprimaRestangular.get().all('lists/pharmacies').withHttpConfig({cache: getDefaultCache()}).getList({query: searchText, includeAllMailOrders: true}).finally(timing.stop);
            }
        }]);
